import { MasterIndex, RepeatingIrrigationEvent } from "verdi-web-client";
import type { IrrigationEventResponse } from "@/api/orval/generated/schemas";

/**
 * Pushes v2 event writes back into MasterIndex. The device status bar and the set save modal's
 * per-event cascade still read events from there, and it is only seeded at login.
 * Like the set version, it only covers writes made in this session — another tab or user still
 * won't show up.
 */

export function syncEventToMasterIndex(event: IrrigationEventResponse, replacesDocId?: string): void {
    removeEventFromMasterIndex(replacesDocId);
    // eslint-disable-next-line no-new -- constructing one registers it in MasterIndex
    new RepeatingIrrigationEvent(event);
}

/**
 * MasterIndex keys events by document `_id`, not by the SCD versionId, so an update has to evict the
 * document it replaces rather than patch it.
 */
export function removeEventFromMasterIndex(docId: string | undefined): void {
    const existing = docId ? MasterIndex.repeatingEvent.byID[docId] : undefined;
    if (!existing) {
        return;
    }
    // Local removal only: `delete()` skips the v1 DELETE when `ghost` is set, which is how the CSV
    // importer drops events it didn't create.
    (existing as unknown as { ghost: boolean }).ghost = true;
    existing.delete().catch((error: unknown) => {
        console.warn(error);
    });
}
